export default __webpack_public_path__ + "static/media/Bug--TrackerLogo.efab2654.svg";